import lenisScroll from './module/lenisScroll.js'
import menuMobile from './module/menuMobile.js'
import scrollMarkers from './module/scrollMarkers.js'
import transitions from './module/transitions.js';
import cookies from './module/cookies.js'
import darkModeOS from './module/darkModeOS.js'
import { initGSAP, refreshScrollTrigger } from './module/gsap.js';
import preventZoom from './module/preventZoom.js'
import alertRotateDevice from './module/alertRotateDevice.js'
import searchFilterBlog from './module/searchFilterBlog.js'
import searchFilterMiembros from './module/searchFilterMiembros.js'
import searchPaginationCategory from './module/searchPaginationCategory.js'
import rowDocHoverBack from './module/rowDocHoverBack.js'

let transitionListenerAdded = false
let transitionsInitialized = false

function modules(deviceData) {
  lenisScroll()
  menuMobile(deviceData)
  scrollMarkers(deviceData)
  darkModeOS(cookies)
  initGSAP(deviceData)
  preventZoom()
  alertRotateDevice(deviceData.isDesktop, deviceData.isBigTablet, deviceData.isMobile)
  if (deviceData.page === 'blog') searchFilterBlog()
  if (deviceData.page === 'miembros') searchFilterMiembros()
  if (document.querySelector('.category-list')) searchPaginationCategory()
  if (deviceData.page === 'academia') rowDocHoverBack()

  setTimeout(() => {
    refreshScrollTrigger();
  }, 100);
}

function functions(deviceData) {
  // console.log(deviceData);

  window.deviceData = deviceData

  if (deviceData?.isDesktop && !transitionsInitialized) {
    transitions()
    transitionsInitialized = true
  }

  modules(deviceData)

  // Agregar listener solo una vez
  if (deviceData?.isDesktop && !transitionListenerAdded) {
    window.addEventListener('page-transition-complete', () => {
      // console.log('Re-inicializando módulos...');

      // Actualizar deviceData con nueva página
      const updatedDeviceData = {
        ...window.deviceData,
        page: document.body.dataset.page
      };

      window.deviceData = updatedDeviceData

      // Re-inicializar módulos principales
      modules(updatedDeviceData)

    })
    transitionListenerAdded = true;
  }

}

export default functions
